import * as actionTypes from "../actionTypes";

const initialState = {
  userDisplayName: null,
  userLoginAlias: null,
  userEmail: null,
  authToken: null,
  isAuthenticated: false,
  persistIn: null
};

export default function bosUserReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_BOSUSER:
      return {
        ...state,
        userDisplayName: data.newDisplayName,
        userLoginAlias: data.newLoginAlias,
        userEmail: data.newEmail,
        authToken: data.newAuthToken,
        isAuthenticated: data.newAuthToken === null || data.newAuthToken === "null" || data.newAuthToken === "undefined" ? false : true,
        persistIn: data.newPersistIn
      };
    case actionTypes.CLEAR_BOSUSER:
      return initialState;
    default:
      return state;
  }
}
